import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grow" }
const _hoisted_2 = { class: "self-stretch text-paragraph-color text-base break-words" }
const _hoisted_3 = {
  key: 0,
  class: "h-6 float-left flex flex-wrap place-content-center mr-1.5"
}
const _hoisted_4 = { class: "flex-col justify-end items-start gap-2.5 empty:hidden" }

import { IReviewSummaryItem } from '@/interfaces';

// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewSummaryItem',
  props: {
    item: {},
    isLastReviewSummaryItem: { type: Boolean },
    isSelfService: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["self-stretch border-racq-pale-blue-border flex-col justify-start items-start flex", {
      'gap-4': _ctx.isSelfService,
      'md:gap-2': _ctx.isSelfService,
      'pb-2': _ctx.isSelfService && _ctx.isLastReviewSummaryItem,
      'border-b pb-5': !_ctx.isLastReviewSummaryItem,
    }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["self-stretch pt-px flex justify-between", `${_ctx.isSelfService ? 'flex-col md:flex-row gap-2 md:gap-4' : 'flex-row gap-4'}`])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createElementVNode("div", _hoisted_2, [
            ((_ctx.item.fields?.icon ?? _ctx.item.icon)?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon h-4 w-4 ${_ctx.item.fields?.icon?.value ?? _ctx.item.icon.value}`)
                  }, null, 2)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "content")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "edit")
        ])
      ], 2),
      _renderSlot(_ctx.$slots, "secondaryLinks"),
      _renderSlot(_ctx.$slots, "subContent")
    ], 2),
    _renderSlot(_ctx.$slots, "showMore")
  ], 64))
}
}

})